import React, { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { DATE_RANGE_OPTIONS, PAYMENT_OPTIONS } from "./clientsUi";

export const DEFAULT_FILTERS = { year: "all", operator: "all", dateRange: "all", paymentStatus: "all" };
export const countActiveFilters = (f) => Object.keys(DEFAULT_FILTERS).filter((k) => f[k] && f[k] !== "all").length;

// Filters live in a sheet (bottom on mobile, right on desktop) — never four
// selects always open. Draft state → "Applica filtri" commits.
export default function ClientsFiltersSheet({ open, onOpenChange, filters, onApply, years, team, mobile }) {
  const [draft, setDraft] = useState(filters);
  useEffect(() => { if (open) setDraft(filters); }, [open, filters]);

  const Field = ({ label, value, onChange, children, testid }) => (
    <div className="space-y-1.5">
      <Label className="label-uppercase text-neutral-600">{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-11 rounded-md bg-white" data-testid={testid}><SelectValue /></SelectTrigger>
        <SelectContent>{children}</SelectContent>
      </Select>
    </div>
  );

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side={mobile ? "bottom" : "right"} className={`${mobile ? "rounded-t-2xl max-h-[88vh] overflow-y-auto" : "sm:max-w-md"} flex flex-col`} data-testid="clients-filters-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="font-serif-heading text-2xl">Filtri</SheetTitle>
          <SheetDescription>Affina l'elenco clienti.</SheetDescription>
        </SheetHeader>
        <div className="space-y-4 py-4 flex-1">
          <Field label="Anno" value={draft.year} onChange={(v) => setDraft({ ...draft, year: v })} testid="filter-year">
            <SelectItem value="all">Tutti gli anni</SelectItem>
            {(years || []).map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}
          </Field>
          <Field label="Operatore" value={draft.operator} onChange={(v) => setDraft({ ...draft, operator: v })} testid="filter-operator">
            <SelectItem value="all">Tutti gli operatori</SelectItem>
            {(team || []).map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}
          </Field>
          <Field label="Data matrimonio" value={draft.dateRange} onChange={(v) => setDraft({ ...draft, dateRange: v })} testid="filter-date-range">
            {DATE_RANGE_OPTIONS.map((o) => <SelectItem key={o.key} value={o.key}>{o.label}</SelectItem>)}
          </Field>
          <Field label="Pagamento" value={draft.paymentStatus} onChange={(v) => setDraft({ ...draft, paymentStatus: v })} testid="filter-payment">
            {PAYMENT_OPTIONS.map((o) => <SelectItem key={o.key} value={o.key}>{o.label}</SelectItem>)}
          </Field>
        </div>
        <div className="grid grid-cols-2 gap-2 pt-2 border-t border-border">
          <Button variant="outline" className="h-11 rounded-md" onClick={() => setDraft(DEFAULT_FILTERS)} data-testid="filters-reset">Azzera</Button>
          <Button className="h-11 rounded-md" onClick={() => { onApply(draft); onOpenChange(false); }} data-testid="filters-apply">Applica filtri</Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
